import { AuthDispatchers } from './auth/auth.dispatchers';
import { ProfileDispatchers } from './profile/profile.dispatchers';
import { MyProfileDispatchers } from './myProfile/myProfile.dispatchers';
import { ChatDispatchers } from './chats/chat.dispatchers';
import { MessageDispatchers } from './messages/message.dispatchers';
import { CampaignDispatchers } from './campaigns/campaign.dispatchers';
import { CampaignUIDispatchers } from './campaignsUI/campaignUI.dispatchers';
import { CouponDispatchers } from './coupons/coupon.dispatchers';
import { CouponUIDispatchers } from './couponsUI/couponUI.dispatchers';
import { ChatMemberDispatchers } from './chatMembers/chatMember.dispatchers';
import { AppConfigDispatchers } from './channelAppConfig/appConfig.dispatchers';
import { AppReleaseDispatchers } from './channelAppReleases/appRelease.dispatchers';
import { ContainerDispatchers } from './channelAppContainers/container.dispatchers';
import { InstantDispatchers } from './instants/instant.dispatchers';
import { EventUiDispatchers } from './eventsUI/eventUI.dispatchers';
import { AppMenuDispatchers } from './channelAppMenu/appMenu.dispatchers';
import { AppPublishingDispatchers } from './appPublishing/appPublishing.dispatchers';
import { MediaCenterDispatchers } from './mediaCenter/mediaCenter.dispatchers';
import { InstantPageDispatchers } from './channelAppInstantPage/instantPage.dispatchers';
import { BookingUiDispatchers } from './bookingsUI/bookingUI.dispatchers';
import { BookingPeriodsDispatchers } from './bookingPeriods/bookingPeriods.dispatchers';
import { MyBookingsDispatchers } from './myBookings/myBookings.dispatchers';
import { PaymentDispatchers } from './payments/payment.dispatchers';
import { BulkDispatchers } from './bulk/bulk.dispatchers';
import { AppConfigHistoryDispatchers } from './appConfigHistory/appConfigHistory.dispatchers';
import { MESSAGE_SEEN_CALLBACK, MESSAGE_CALLBACK, TOKEN_AUTH_OK_CALLBACK, TOKEN_CALLBACK, TOKEN_CHANGE_CALLBACK, QR_CODE_CALLBACK, CONTACTS_CALLBACK, USER_CALLBACK, MESSAGE_ACK_CALLBACK, MY_PROFILE_CALLBACK, MESSAGE_DELIVERED_CALLBACK, INVALIDATE_USER_CALLBACK, CHAT_LIST_CALLBACK, CHAT_CALLBACK, CHAT_INVALID_CALLBACK, CHAT_COUNTERS_CALLBACK, LIKE_MESSAGE_ACK, CHAT_MEMBER_COUNT, LEFT_CHAT_CALLBACK, CHAT_SELECTED_CALLBACK, MESSAGE_SCHEDULED_CALLBACK, MESSAGE_SCHEDULED_CANCELED_CALLBACK, CAMPAIGNS_CALLBACK, CAMPAIGN_CALLBACK, COUPONS_CALLBACK, COUPON_CALLBACK, TAGS_CALLBACK, CHAT_MEMBER_CALLBACK, APP_CONFIG_CALLBACK, REQUEST_CONFIG, PUBLISH_APP, CREATE_ARTICLE_ACK_CALLBACK, CREATE_EVENT_REF, TEMPLATE_CALLBACK, APP_RELEASE_CALLBACK, TAGS_VALUE_CALLBACK, TAB_TAGS_REF_APP, ADMIN_QR_CODE_CALLBACK, SUB_CHAT_LIST_CALLBACK, CREATE_GROUP_REF, UPDATE_EVENT_REF, AUTH_PRIVILEGE_CALLBACK, CREATE_CHANNEL_REF, CHAT_ADMINISTRATORS_CALLBACK, MY_MENUS_CALLBACK, APP_MENU_CALLBACK, MY_MENU_CALLBACK, APP_MENUS_CALLBACK, UPDATE_APP_CHANNEL_REF, MY_MEMBER_CHATS_CALLBACK, MY_MEMBERS_CALLBACK, TAB_TAGS_REF_CHANNEL, PUBLISH_CHANNEL, ROLES_CALLBACK, MY_PAGE_CALLBACK, MY_PAGES_CALLBACK, MY_CALL_BACK_STATS_CALLBACK, APP_RELEASES_CALLBACK, entityStatuses, APP_STORE_CALLBACK, MY_MEDIA_CALLBACK, INSTANT_PAGE_CALLBACK, INSTANT_PAGES_CALLBACK, REQUEST_APPLE_CODE_CALLBACK, GENERATE_APP_REF, CREATE_BOOKING_SPACE_REF, BOOKING_PERIODS_CALLBACK, MY_BOOKINGS_CALLBACK, PAYMENT_TOKEN_CALLBACK, APP_CONFIG_HISTORY_CALLBACK, APP_CONFIGS_HISTORY_LIST_CALLBACK, PAYMENT_SET_CALLBACK, PAYMENT_CALLBACK, BOTS_CALLBACK, BOT_CALLBACK, BOT_TEMPLATES_CALLBACK, PASSWORD_SET_CALLBACK, ADD_BOT_AS_ADMIN_REF, CREATE_BOT_REF, APP_CHANNEL_DATA_CALLBACK, GET_BOOKING_EXCEPTIONS_CALLBACK, SET_BOOKING_EXCEPTIONS_CALLBACK, RecordTypes, MAP_SERVICE_CALLBACK, MAP_SERVICES_CALLBACK, CREATE_MAP_SERVICE_REF, PUBLISH_BOT_CALLBACK, MAP_MARKERS_CALLBACK, MAP_MARKER_CALLBACK, CREATE_MAP_MARKER_REF, MAP_ROUTE_CALLBACK, MAP_ROUTES_CALLBACK, CREATE_MAP_ROUTE_REF, MAP_TRIP_CALLBACK, CREATE_MAP_TRIP_REF, MAP_TRIPS_CALLBACK, MAP_TRIP_USER_CALLBACK, CREATE_MAP_TRIP_USER_REF, MAP_TRIP_USERS_CALLBACK, MAP_STOP_TIME_CALLBACK, MAP_STOP_TIMES_CALLBACK, CALENDAR_CALLBACK, CALENDAR_DETAILS_CALLBACK, CALENDARS_CALLBACK, CREATE_CALENDAR_REF, EVENT_CHANNEL, BOOKING_CHANNEL, GROUP, CHANNEL, CONFIG_QR_CODE_CALLBACK, DEFAULT_CHAT_LIST_CALLBACK, SERVICE_ORDERS_CALLBACK, PAYMENT_ORDERS_CALLBACK, PAYMENT_PROVIDERS_CALLBACK, SET_PAYMENT_PROVIDER_CALLBACK, PRODUCTS_CALLBACK, PRODUCT_CALLBACK, BUNDLE_CALLBACK, BUNDLES_CALLBACK, USER_BALANCE_CALLBACK, USER_PRODUCT_BALANCE_CALLBACK, PACKAGES_CALLBACK, PACKAGE_CALLBACK, APPS_CALLBACK, UPDATE_GROUP_REF, UPDATE_CHANNEL_REF, MY_MEMBER_CALLBACK, PAYMENT_ORDER_USERS_REF, CASH_PAYMENT_CALLBACK, MSTORE_CALLBACK, MSTORES_CALLBACK, SUBMENU_CALLBACK, MY_BOOKING_USERS_REF, REQUEST_MY_BOOKING, PAYMENT_ORDER_GROUP_REF, STOREMENU_CALLBACK, STOREMENUS_CALLBACK, SUBMENUS_CALLBACK, CANCEL_MY_BOOKING_REF, CREATE_PACKAGE_REF, CREATE_BUNDLE_REF, CREATE_PRODUCT_REF, CREATE_STORE_REF, CREATE_STORE_MENU_REF, CREATE_SUB_MENU_REF, TICKET_STATUS_CALLBACK, GROUP_DELETED_CALLBACK, CREATE_BULK_REF, CREATE_CAMPAIGN_REF, CREATE_COUPON_REF, UPDATE_BULK_REF, CREATE_BOT_MENU_REF, ADS_PROVIDERS_CALLBACK, AdsConfig, CREATE_VIRTUAL_APP_REF, UPDATE_VIRTUAL_APP_REF, CREATE_COUPON_POPUP_REF, UserStatus, DELETE_MEMBER_FROM_MAIN_CHAT_REF, DELETE_MEMBER_FROM_SUB_CHAT_REF, WHITELIST_CALLBACK, BLACKLIST_CALLBACK, ADD_BLACKLIST_ACK_CALLBACK, DELETE_BLACKLIST_ACK_CALLBACK, BLACKLIST_PATTERNS_CALLBACK, DELETE_BLACKLIST_PATTERNS_CALLBACK, ADD_BLACKLIST_PATTERNS_ACK_CALLBACK, ADD_WHITELIST_CALLBACK, DELETE_WHITELIST_CALLBACK, WHITELIST_PATTERNS_CALLBACK, ADD_WHITELIST_PATTERNS_CALLBACK, DELETE_WHITELIST_PATTERNS_CALLBACK, CONNECTE_STRIPE_CALLBACK, APP_CHANNEL_SETTINGS_CALLBACK, APP_CONFIG_HISTORY_INFO, MAP_ACTIVE_TRIPS_CALLBACK, MAP_ACCOUNT_LINKS_CALLBACK, MAP_LINKED_ACCOUNTS_CALLBACK, MAP_ACCOUNT_LINK_CALLBACK, MAP_ASSIGN_TRIPS_CALLBACK, MAP_TRIPS_ASSIGN_CALLBACK, OTHER_TRIPS_CALLBACK, GET_SMTP_CALLBACK } from 'src/models/constants';
import { BookingExceptionsDispatchers } from './bookingExceptions/bookingExceptions.dispatchers';
import { AppChannelDataDispatchers } from './appChannelData/appChannelData.dispatchers';
import { MapServiceDispatchers } from './mapServices/mapService.dispatchers';
import { MapMarkerDispatchers } from './mapMarkers/mapMarker.dispatchers';
import { MapRouteDispatchers } from './mapRoutes/mapRoute.dispatchers';
import { MapTripDispatchers } from './mapTrips/mapTrip.dispatchers';
import { MapTripUserDispatchers } from './mapTripUsers/mapTripUser.dispatchers';
import { CalendarUiDispatchers } from './calendarUI/calendarUI.dispatchers';
import { SubGroupUiDispatchers } from './subGroupsUI/subGroupsUI.dispatchers';
import { SubChannelUiDispatchers } from './subChannelsUI/subChannelsUI.dispatchers';
import { MembersUiDispatchers } from './membersUI/membersUI.dispatchers';
import { ServiceOrdersUiDispatchers } from './serviceOrdersUI/serviceOrdersUI.dispatchers';
import { PaymentOrdersUiDispatchers } from './paymentOrdersUI/paymentOrdersUI.dispatchers';
import { PaymentProvidersDispatchers } from './paymentProviders/paymentProviders.dispatchers';
import { ProductsUiDispatchers } from './productsUI/productsUI.dispatchers';
import { BundlesUiDispatchers } from './bundlesUI/bundlesUI.dispatchers';
import { PackagesUiDispatchers } from './packagesUI/packagesUI.dispatchers';
import { AppLocalInfoDispatchers } from './channelAppLocalInfo/appLocalInfo.dispatchers';
import { StoreUiDispatchers } from './storesUI/storeUI.dispatchers';
import { SubMenuUiDispatchers } from './subMenuUI/subMenuUI.dispatchers';
import { StoreMenuUiDispatchers } from './storeMenuUI/storeMenuUI.dispatchers';
import { AdsProvidersDispatchers } from './adsProvider/adsProvider.dispatchers';
import { MenuUIDispatchers } from './menusUI/menuUI.dispatchers';
import { BlackListUiDispatchers } from './balckListUI/blackListUI.dispatchers';
import { BlackListPatternsUiDispatchers } from './balckListPatternsUI/blackListPatternsUI.dispatchers';
import { VirtualAppUiDispatchers } from './virtualAppsUI/virtualAppsUI.dispatchers';
import { WhitelistPatternsUiDispatchers } from './whitelistPatternsUI/whitelistPatternsUI.dispatchers';
import { WhitelistUiDispatchers } from './whitelistMainUI/whitelistMainUI.dispatchers';
import { AppChannelSettingsDispatchers } from './appChannelSettings/appChannelSettings.dispatchers';
import { MapStopTimeDispatchers } from './mapStopTime/mapStopTime.dispatchers';
import { MapTripHistoryDispatchers } from './mapTripsHistory/mapTripsHistory.dispatchers';
import { MapTripsNotifiersDispatchers } from './mapTripsNotifiers/mapTripsNotifiers.dispatchers';
import { DriverTripsDispatchers } from './driverAssigned/driverAssigned.dispatchers';
import { MapDriverDispatchers } from './mapTripDriver/mapTripsDriver.dispatchers';
import { MyPageDispatchers } from './channelMyPage/myPage.dispatchers';
import { OtherTripsDispatchers } from './otherDriverTrips/otherDriverTrips.dispatchers';
import { StmpDispatchers } from './smtp/smtp.dispatchers';
import * as i0 from "@angular/core";
import * as i1 from "./auth/auth.dispatchers";
import * as i2 from "./messages/message.dispatchers";
import * as i3 from "./profile/profile.dispatchers";
import * as i4 from "./myProfile/myProfile.dispatchers";
import * as i5 from "./chats/chat.dispatchers";
import * as i6 from "./chatMembers/chatMember.dispatchers";
import * as i7 from "./campaigns/campaign.dispatchers";
import * as i8 from "./campaignsUI/campaignUI.dispatchers";
import * as i9 from "./coupons/coupon.dispatchers";
import * as i10 from "./couponsUI/couponUI.dispatchers";
import * as i11 from "./instants/instant.dispatchers";
import * as i12 from "./channelAppConfig/appConfig.dispatchers";
import * as i13 from "./appConfigHistory/appConfigHistory.dispatchers";
import * as i14 from "./channelAppReleases/appRelease.dispatchers";
import * as i15 from "./channelAppContainers/container.dispatchers";
import * as i16 from "./eventsUI/eventUI.dispatchers";
import * as i17 from "./bookingsUI/bookingUI.dispatchers";
import * as i18 from "./subGroupsUI/subGroupsUI.dispatchers";
import * as i19 from "./subChannelsUI/subChannelsUI.dispatchers";
import * as i20 from "./virtualAppsUI/virtualAppsUI.dispatchers";
import * as i21 from "./membersUI/membersUI.dispatchers";
import * as i22 from "./bookingPeriods/bookingPeriods.dispatchers";
import * as i23 from "./myBookings/myBookings.dispatchers";
import * as i24 from "./channelAppMenu/appMenu.dispatchers";
import * as i25 from "./channelMyPage/myPage.dispatchers";
import * as i26 from "./channelAppInstantPage/instantPage.dispatchers";
import * as i27 from "./appPublishing/appPublishing.dispatchers";
import * as i28 from "./mediaCenter/mediaCenter.dispatchers";
import * as i29 from "./payments/payment.dispatchers";
import * as i30 from "./bulk/bulk.dispatchers";
import * as i31 from "./appChannelData/appChannelData.dispatchers";
import * as i32 from "./bookingExceptions/bookingExceptions.dispatchers";
import * as i33 from "./mapServices/mapService.dispatchers";
import * as i34 from "./mapMarkers/mapMarker.dispatchers";
import * as i35 from "./mapRoutes/mapRoute.dispatchers";
import * as i36 from "./mapTrips/mapTrip.dispatchers";
import * as i37 from "./mapTripUsers/mapTripUser.dispatchers";
import * as i38 from "./calendarUI/calendarUI.dispatchers";
import * as i39 from "./serviceOrdersUI/serviceOrdersUI.dispatchers";
import * as i40 from "./paymentOrdersUI/paymentOrdersUI.dispatchers";
import * as i41 from "./paymentProviders/paymentProviders.dispatchers";
import * as i42 from "./adsProvider/adsProvider.dispatchers";
import * as i43 from "./productsUI/productsUI.dispatchers";
import * as i44 from "./bundlesUI/bundlesUI.dispatchers";
import * as i45 from "./packagesUI/packagesUI.dispatchers";
import * as i46 from "./channelAppLocalInfo/appLocalInfo.dispatchers";
import * as i47 from "./storesUI/storeUI.dispatchers";
import * as i48 from "./subMenuUI/subMenuUI.dispatchers";
import * as i49 from "./storeMenuUI/storeMenuUI.dispatchers";
import * as i50 from "./menusUI/menuUI.dispatchers";
import * as i51 from "./whitelistPatternsUI/whitelistPatternsUI.dispatchers";
import * as i52 from "./whitelistMainUI/whitelistMainUI.dispatchers";
import * as i53 from "./balckListUI/blackListUI.dispatchers";
import * as i54 from "./balckListPatternsUI/blackListPatternsUI.dispatchers";
import * as i55 from "./appChannelSettings/appChannelSettings.dispatchers";
import * as i56 from "./mapTripsHistory/mapTripsHistory.dispatchers";
import * as i57 from "./mapStopTime/mapStopTime.dispatchers";
import * as i58 from "./mapTripsNotifiers/mapTripsNotifiers.dispatchers";
import * as i59 from "./driverAssigned/driverAssigned.dispatchers";
import * as i60 from "./mapTripDriver/mapTripsDriver.dispatchers";
import * as i61 from "./otherDriverTrips/otherDriverTrips.dispatchers";
import * as i62 from "./smtp/smtp.dispatchers";
export class RootStoreService {
    constructor(_authDispatchers, _messageDispatchers, _profileDispatcher, _myProfileDispatcher, _chatDispatchers, _chatMemberDispatchers, _campaignDispatchers, _campaignUIDispatchers, _couponDispatchers, _couponUIDispatchers, _instantArticleDispatchers, _appConfigDispatchers, _appConfigHistoryDispatchers, _appReleaseDispatchers, _containerDispatchers, _eventUiDispatchers, _bookingUiDispatchers, _subGroupUiDispatchers, _subChannelUiDispatchers, _virtualAppUiDispatchers, _membersUiDispatchers, _bookingPeriodsDispatchers, _myBookingsDispatchers, _appMenuDispatchers, _myPageDispatchers, _instantPageDispatchers, _appPublishingDispatchers, _mediaCenterDispatchers, _paymentDispatchers, _bulkDispatchers, _appChannelDataDispatchers, _bookingExceptionsDispatchers, _mapServiceDispatchers, _mapMarkerDispatchers, _mapRouteDispatchers, _mapTripDispatchers, _mapTripUserDispatchers, _calendarUiDispatchers, _serviceOrdersUiDispatchers, _paymentOrdersUiDispatchers, _paymentProvidersDispatchers, _adsProvidersDispatchers, _productsDispatchers, _bundlesDispatchers, _packagesDispatchers, _appLocalInfoDispatchers, _storesDispatchers, _subMenuDispatchers, _storeMenuDispatchers, _menuUIDispatchers, _whitelistPatternsDispatchers, _whitelistDispatchers, _blackListUiDispatchers, _blacklistPatternsUiDispatchers, _appChannelSettingsDispatchers, _mapTripHistoryDispatchers, _mapStopTimeDispatchers, mapTripsNotifiersDispatchers, _driverTripsDispatchers, _mapDriverTripsDispatchers, _otherTripsDispatchers, _smtpDispatchers) {
        this._authDispatchers = _authDispatchers;
        this._messageDispatchers = _messageDispatchers;
        this._profileDispatcher = _profileDispatcher;
        this._myProfileDispatcher = _myProfileDispatcher;
        this._chatDispatchers = _chatDispatchers;
        this._chatMemberDispatchers = _chatMemberDispatchers;
        this._campaignDispatchers = _campaignDispatchers;
        this._campaignUIDispatchers = _campaignUIDispatchers;
        this._couponDispatchers = _couponDispatchers;
        this._couponUIDispatchers = _couponUIDispatchers;
        this._instantArticleDispatchers = _instantArticleDispatchers;
        this._appConfigDispatchers = _appConfigDispatchers;
        this._appConfigHistoryDispatchers = _appConfigHistoryDispatchers;
        this._appReleaseDispatchers = _appReleaseDispatchers;
        this._containerDispatchers = _containerDispatchers;
        this._eventUiDispatchers = _eventUiDispatchers;
        this._bookingUiDispatchers = _bookingUiDispatchers;
        this._subGroupUiDispatchers = _subGroupUiDispatchers;
        this._subChannelUiDispatchers = _subChannelUiDispatchers;
        this._virtualAppUiDispatchers = _virtualAppUiDispatchers;
        this._membersUiDispatchers = _membersUiDispatchers;
        this._bookingPeriodsDispatchers = _bookingPeriodsDispatchers;
        this._myBookingsDispatchers = _myBookingsDispatchers;
        this._appMenuDispatchers = _appMenuDispatchers;
        this._myPageDispatchers = _myPageDispatchers;
        this._instantPageDispatchers = _instantPageDispatchers;
        this._appPublishingDispatchers = _appPublishingDispatchers;
        this._mediaCenterDispatchers = _mediaCenterDispatchers;
        this._paymentDispatchers = _paymentDispatchers;
        this._bulkDispatchers = _bulkDispatchers;
        this._appChannelDataDispatchers = _appChannelDataDispatchers;
        this._bookingExceptionsDispatchers = _bookingExceptionsDispatchers;
        this._mapServiceDispatchers = _mapServiceDispatchers;
        this._mapMarkerDispatchers = _mapMarkerDispatchers;
        this._mapRouteDispatchers = _mapRouteDispatchers;
        this._mapTripDispatchers = _mapTripDispatchers;
        this._mapTripUserDispatchers = _mapTripUserDispatchers;
        this._calendarUiDispatchers = _calendarUiDispatchers;
        this._serviceOrdersUiDispatchers = _serviceOrdersUiDispatchers;
        this._paymentOrdersUiDispatchers = _paymentOrdersUiDispatchers;
        this._paymentProvidersDispatchers = _paymentProvidersDispatchers;
        this._adsProvidersDispatchers = _adsProvidersDispatchers;
        this._productsDispatchers = _productsDispatchers;
        this._bundlesDispatchers = _bundlesDispatchers;
        this._packagesDispatchers = _packagesDispatchers;
        this._appLocalInfoDispatchers = _appLocalInfoDispatchers;
        this._storesDispatchers = _storesDispatchers;
        this._subMenuDispatchers = _subMenuDispatchers;
        this._storeMenuDispatchers = _storeMenuDispatchers;
        this._menuUIDispatchers = _menuUIDispatchers;
        this._whitelistPatternsDispatchers = _whitelistPatternsDispatchers;
        this._whitelistDispatchers = _whitelistDispatchers;
        this._blackListUiDispatchers = _blackListUiDispatchers;
        this._blacklistPatternsUiDispatchers = _blacklistPatternsUiDispatchers;
        this._appChannelSettingsDispatchers = _appChannelSettingsDispatchers;
        this._mapTripHistoryDispatchers = _mapTripHistoryDispatchers;
        this._mapStopTimeDispatchers = _mapStopTimeDispatchers;
        this.mapTripsNotifiersDispatchers = mapTripsNotifiersDispatchers;
        this._driverTripsDispatchers = _driverTripsDispatchers;
        this._mapDriverTripsDispatchers = _mapDriverTripsDispatchers;
        this._otherTripsDispatchers = _otherTripsDispatchers;
        this._smtpDispatchers = _smtpDispatchers;
    }
    redirectMessage(data) {
        if (data.error) {
            switch (Number(data.error)) {
                case 100098 /* TokenExpired */:
                case 199990 /* NoPermission */:
                case 100099 /* AuthError */:
                    this._authDispatchers.reciveAuthNot();
                    break;
                case 199992 /* MultiLogin */:
                    this._authDispatchers.reciveMultiLogin();
                    break;
                case 500099 /* OldPasswordNotCorrect */:
                case 510023 /* PasswordTooShort */:
                case 510019 /* PasswordTooLong */:
                case 510024 /* PasswordMustContainLowerCase */:
                case 510025 /* PasswordMustContainUpperCase */:
                case 510026 /* PasswordMustContainDigit */:
                case 510027 /* PasswordMustContainSpecial */:
                case 510028 /* PasswordMatchesPattern */:
                case 510029 /* PasswordMatchesDictionary */:
                case 510030 /* PasswordInHistory */:
                case 510031 /* PasswordsDoNotMatch */:
                    this._authDispatchers.receiveChangePasswordError(data.error);
                    break;
                case 500039 /* GoogleAccountNotOpened */:
                case 500041 /* GoogleReleaseManagerNotSetup */:
                case 500042 /* AppNameNotProvided */:
                case 500043 /* GoogleScJsonNotProvided */:
                case 500044 /* AppleAccountNotOpened */:
                case 500045 /* AppleAppManagerNotSetup */:
                case 500046 /* AppleAppNameNotProvided */:
                case 500047 /* GooglePackageIdNotProvided */:
                case 500048 /* AppleBundleIdNotProvided */:
                case 500049 /* AppleTeamNameNotProvided */:
                case 500050 /* GoogleScJsonInvalidFormat */:
                case 500053 /* AppSpecificPasswordNotProvided */:
                case 500056 /* GooglePackageIdHasInvalidFormat */:
                case 500057 /* AppleBundleIdHasInvalidFormat */:
                case 500066 /* AppleDeveloperPasswordNotProvided */:
                case 500073 /* ApplePushNotiKeyNotProiveded */:
                case 500074 /* AppleUserNotProvided */:
                case 500075 /* AndroidFormatHasWrongValue */:
                case 500052 /* AppleAppManagerNotConfirmed */:
                case 500076 /* AppNameIsAlreadyUsed */:
                    this._appPublishingDispatchers.receivePublishInfoError(data.error);
                    break;
                case 500069 /* DifferentCurrency */:
                case 500088 /* SKUIsAlreadyUsed */:
                case 500090 /* PatternNotmatched */:
                case 500089 /* InvalidPattern */:
                case 500096 /* NotifierIsAlreadyExist */:
                case 500119 /* DifferentSubChannels */:
                    this._appPublishingDispatchers.receiveErrorCode(data.error);
                    break;
                case 160014 /* UniqueBotNameError */:
                    this._profileDispatcher.receivePublishBotError(data.error);
                    break;
                case 100012 /* DeleteChatError */:
                    this._chatDispatchers.chatDeletedError(data.group_id, data.error);
                    break;
                case 100001 /* UnAuthenticated */:
                    window.location.reload();
                    break;
                default:
                    break;
            }
        }
        else if (data.method) {
            switch (data.method) {
                case QR_CODE_CALLBACK:
                    this._authDispatchers.reciveAuthQR(data);
                    break;
                case TOKEN_CALLBACK:
                    this._authDispatchers.reciveAuthToken(data);
                    break;
                case TOKEN_CHANGE_CALLBACK:
                    this._authDispatchers.reciveAuthTokenChange(data);
                    break;
                case TOKEN_AUTH_OK_CALLBACK:
                    const localData = Object.assign({}, data, { chatId: data.chat_id });
                    this._authDispatchers.reciveAuthOK(localData);
                    // For merchant project only rcvd this payment info
                    this._paymentDispatchers.rcvdPaymentAuthInfo(data);
                    this._paymentDispatchers.getPricePlans();
                    break;
                case ADMIN_QR_CODE_CALLBACK:
                    this._authDispatchers.receiveAdminQR(data.qrCode, data.chat_id);
                    break;
                case AUTH_PRIVILEGE_CALLBACK:
                    this._authDispatchers.receiveAuthPrivilege(data.privileges, data.reference);
                    break;
                case PASSWORD_SET_CALLBACK:
                    this._authDispatchers.receiveChangePasswordSet();
                    break;
                case MESSAGE_CALLBACK:
                    this._messageDispatchers.initReceivedMessage(data);
                    break;
                case MESSAGE_ACK_CALLBACK:
                    this._messageDispatchers.messageSent(data.ack);
                    break;
                case MESSAGE_DELIVERED_CALLBACK:
                    this._messageDispatchers.messageDelivered(data);
                    break;
                case MESSAGE_SEEN_CALLBACK:
                    this._messageDispatchers.messagesSeenReceived(data.message_ids);
                    break;
                case MY_PROFILE_CALLBACK:
                    this._myProfileDispatcher.myProfileReceiving(data.user);
                    break;
                case CONTACTS_CALLBACK:
                    this._profileDispatcher.contactsReceived(data.contacts);
                    break;
                case BOTS_CALLBACK:
                    this._profileDispatcher.contactsReceived(data.bots, true);
                    break;
                case BOT_TEMPLATES_CALLBACK:
                    this._profileDispatcher.contactsReceived(data.bot_templates, false, true);
                    break;
                case USER_CALLBACK:
                    this._profileDispatcher.contactDetailsReceived(data.user);
                    break;
                case BOT_CALLBACK:
                    if (data.reference && ADD_BOT_AS_ADMIN_REF === data.reference) {
                        this._profileDispatcher.botAddedAsAdmin(data.bot.id);
                    }
                    else if (data.bot &&
                        data.status &&
                        data.status === entityStatuses.DELETED) {
                        this._profileDispatcher.myBotDeleted(data.bot.id);
                    }
                    else if (data.reference &&
                        CREATE_BOT_REF === data.reference &&
                        data.bot) {
                        this._profileDispatcher.botCreated(data.bot.id, data.bot.name);
                        this._profileDispatcher.profileInvalidated(data.bot.id);
                    }
                    else {
                        this._profileDispatcher.contactDetailsReceived(data.bot);
                    }
                    break;
                case PUBLISH_BOT_CALLBACK: {
                    this._profileDispatcher.profileInvalidated(data.id);
                    break;
                }
                case INVALIDATE_USER_CALLBACK:
                    this._profileDispatcher.profileInvalidated(data.user_id);
                    break;
                case CHAT_INVALID_CALLBACK:
                    if (CREATE_EVENT_REF === data.reference) {
                        const createdEvent = this.chatReceived(data);
                        this._eventUiDispatchers.eventPhotoUploadUI(createdEvent);
                        this._eventUiDispatchers.resetEventPaging();
                    }
                    else if (CREATE_BOOKING_SPACE_REF === data.reference) {
                        const createdBookingSpace = this.chatReceived(data);
                        // may be I'll change this event name
                        this._bookingUiDispatchers.bookingPhotoUploadUI(createdBookingSpace);
                        this._bookingUiDispatchers.resetBookingPaging();
                    }
                    else if (CREATE_GROUP_REF === data.reference) {
                        const createdGroup = this.chatReceived(data);
                        this._subGroupUiDispatchers.subGroupPhotoUploadUI(createdGroup);
                        this._subGroupUiDispatchers.resetSubGroupPaging();
                    }
                    else if (CREATE_CHANNEL_REF === data.reference) {
                        const createdGroup = this.chatReceived(data);
                        this._subChannelUiDispatchers.subChannelPhotoUploadUI(createdGroup);
                        this._subChannelUiDispatchers.resetSubChannelPaging();
                    }
                    else if (CREATE_VIRTUAL_APP_REF === data.reference) {
                        const createdGroup = this.chatReceived(data);
                        this._virtualAppUiDispatchers.virtualAppPhotoUploadUI(createdGroup);
                        this._virtualAppUiDispatchers.resetVirtualAppPaging();
                    }
                    else if (CREATE_BULK_REF === data.reference ||
                        UPDATE_BULK_REF === data.reference) {
                        if (data.recordIndex) {
                            this._bulkDispatchers.recordCreated(data.recordIndex, RecordTypes.CHAT, data.chat_id, data.reference);
                        }
                    }
                    else {
                        this._chatDispatchers.chatInvalidated(data.chat_id);
                    }
                    break;
                case CHAT_CALLBACK:
                    this._chatDispatchers.chatDetailsReceived(data);
                    if (UPDATE_EVENT_REF === data.reference) {
                        this._eventUiDispatchers.closeEventEditUI();
                    }
                    else if (data.reference === UPDATE_GROUP_REF) {
                        this._subGroupUiDispatchers.closeEditSubGroupUI();
                    }
                    else if (data.reference === UPDATE_CHANNEL_REF) {
                        this._subChannelUiDispatchers.closeEditSubChannelUI();
                    }
                    else if (data.reference === UPDATE_VIRTUAL_APP_REF) {
                        this._virtualAppUiDispatchers.closeEditVirtualAppUI();
                    }
                    else if (UPDATE_APP_CHANNEL_REF === data.reference) {
                        const appInfo = {};
                        appInfo.channel_name = data.chat.title;
                        this._appConfigDispatchers.updateAppInfo(appInfo);
                    }
                    break;
                case TAGS_CALLBACK:
                    this._chatDispatchers.tagsReceived(data);
                    if (data.chat && data.chat.recordIndex) {
                        this._bulkDispatchers.recordCreated(data.chat.recordIndex, RecordTypes.TAG);
                    }
                    break;
                case DEFAULT_CHAT_LIST_CALLBACK:
                    this._authDispatchers.reciveAuthChatList(data);
                    this._chatDispatchers.chatListReceived(data);
                    break;
                case CHAT_LIST_CALLBACK:
                    if (data.ref &&
                        data.ref === PAYMENT_ORDER_GROUP_REF &&
                        data.chat_list) {
                        const groupNamesObj = {};
                        data.chat_list.forEach(chat => {
                            groupNamesObj[chat.id] = chat.name;
                        });
                        this._paymentOrdersUiDispatchers.paymentOrdersGroupsReceived(groupNamesObj);
                    }
                    else {
                        this._chatDispatchers.chatListReceived(data);
                    }
                    break;
                case SUB_CHAT_LIST_CALLBACK:
                    if (data.type && data.type.length > 0 && data.chat_list) {
                        data.type.forEach(type => {
                            this._chatDispatchers.subChatListReceived({
                                chat_list: data.chat_list.filter(chat => chat.type === type)
                            }, type);
                        });
                        if (EVENT_CHANNEL === data.type[0]) {
                            this._eventUiDispatchers.receivedEventHistoryChunk(data.eop, data.sop, data.chat_list);
                        }
                        else if (BOOKING_CHANNEL === data.type[0]) {
                            this._bookingUiDispatchers.receivedBookingHistoryChunk(data.eop, data.sop, data.chat_list);
                        }
                        else if (GROUP === data.type[0]) {
                            this._subGroupUiDispatchers.receivedSubGroupHistoryChunk(data.eop, data.sop, data.chat_list);
                        }
                        else if (CHANNEL === data.type[0]) {
                            if (data.vapp && data.vapp == 1) {
                                this._virtualAppUiDispatchers.receivedVirtualAppHistoryChunk(data.eop, data.sop, data.chat_list);
                            }
                            else {
                                this._subChannelUiDispatchers.receivedSubChannelHistoryChunk(data.eop, data.sop, data.chat_list);
                            }
                        }
                    }
                    else {
                        this._chatDispatchers.subChatListReceived(data);
                    }
                    break;
                case CHAT_SELECTED_CALLBACK:
                    const auth = {};
                    auth.chatId = data.chat_id;
                    auth.progressWeb = data.progressWeb;
                    auth.mode = data.mode;
                    auth.appConfig = data.appConfig;
                    auth.is_nandbox = data.is_nandbox;
                    auth.role = data.role;
                    // console.log('here is the new role =>', auth.role);
                    auth.main_group_id = data.main_group_id;
                    this._authDispatchers.receiveAuthChatSelected(auth);
                    break;
                case CHAT_COUNTERS_CALLBACK:
                    this._messageDispatchers.chatCountersReceived(data.message_ids);
                    break;
                case LIKE_MESSAGE_ACK:
                    this._messageDispatchers.likeAckReceived(data);
                    break;
                case CHAT_MEMBER_COUNT:
                    this._chatDispatchers.chatMemberCountReceived(data.chat);
                    break;
                case LEFT_CHAT_CALLBACK:
                    const chatMember = data.chatMember;
                    if (this._authDispatchers.getLoginID() === chatMember.user.id) {
                        this._chatDispatchers.loggedInLeftChat(chatMember);
                    }
                    break;
                case MESSAGE_SCHEDULED_CALLBACK:
                    this._messageDispatchers.initReceivedMessage(data);
                    break;
                case MESSAGE_SCHEDULED_CANCELED_CALLBACK:
                    this._messageDispatchers.receiveScheduleMessageCanceled(data);
                    break;
                case CAMPAIGNS_CALLBACK:
                    this._campaignUIDispatchers.receivedCampaignHistoryChunk(data.eop, data.sop, data.campaigns);
                    break;
                case CAMPAIGN_CALLBACK:
                    this._campaignDispatchers.campaignReceived(data);
                    if (data.reference === CREATE_CAMPAIGN_REF) {
                        this._campaignUIDispatchers.resetCampaignPaging();
                    }
                    break;
                case COUPONS_CALLBACK:
                    this._couponUIDispatchers.receivedCouponHistoryChunk(data.eop, data.sop, data.coupons);
                    break;
                case COUPON_CALLBACK:
                    this._couponDispatchers.couponReceived(data);
                    if (data.reference === CREATE_COUPON_REF) {
                        this._couponUIDispatchers.resetCouponPaging();
                    }
                    else if (data.reference === CREATE_COUPON_POPUP_REF) {
                        const date = new Date();
                        const year = date.getFullYear();
                        const month = date.getMonth() + 1;
                        const day = date.getDate();
                        const formatMonth = month < 10 ? '0' + month : month;
                        const formatDay = day < 10 ? `0${day}` : day;
                        this._couponUIDispatchers.resetCouponPaging('A', `${year}-${formatMonth}-${formatDay}`);
                    }
                    break;
                case GROUP_DELETED_CALLBACK:
                    this._chatDispatchers.chatDeleted(data.group_id);
                    break;
                case APP_CONFIG_CALLBACK:
                    if (REQUEST_CONFIG === data.reference) {
                        this._appConfigDispatchers.appConfigAck(data.onlineChannelConfigWeb, data.appConfig);
                    }
                    else if (PUBLISH_APP === data.reference) {
                        this._appConfigDispatchers.appConfigPublished(false);
                        this._appConfigHistoryDispatchers.requestAppConfigsHistory();
                    }
                    else if (PUBLISH_CHANNEL === data.reference) {
                        this._appConfigDispatchers.appConfigPublished(true);
                    }
                    else if (GENERATE_APP_REF === data.reference) {
                        this._appReleaseDispatchers.listAppReleases();
                    }
                    break;
                case APP_CONFIG_HISTORY_CALLBACK: {
                    if (data.app_config_history) {
                        this._appConfigDispatchers.appConfigAck(data.app_config_history.onlineChannelConfigWeb, data.app_config_history.appConfig);
                        this._appConfigDispatchers.UpldTempImageToProfile(data.app_config_history.appConfig.app.system.app_info.image_id);
                    }
                    break;
                }
                case APP_CONFIGS_HISTORY_LIST_CALLBACK: {
                    this._appConfigHistoryDispatchers.receiveAppConfigsHistory(data.app_configs_history);
                    break;
                }
                case CREATE_ARTICLE_ACK_CALLBACK:
                    this._instantArticleDispatchers.instantArticleReceived(data);
                    break;
                case TEMPLATE_CALLBACK:
                    this._appConfigDispatchers.receiveAppTemplate(data.onlineChannelConfigWeb, data.appConfig, data.onlineAppConfigIosWeb, data.appConfigIos);
                    break;
                case APP_RELEASE_CALLBACK:
                    if (data.status && data.status === entityStatuses.DELETED) {
                        this._appReleaseDispatchers.removeAppReleaseSuccess(data.id);
                    }
                    else {
                        this._appReleaseDispatchers.rcvdAppRelease(data);
                    }
                    break;
                case APP_RELEASES_CALLBACK:
                    this._appReleaseDispatchers.listAppReleasesSuccess(data.values);
                    break;
                case TAGS_VALUE_CALLBACK:
                    if (TAB_TAGS_REF_APP === data.reference) {
                        this._containerDispatchers.receiveTagValues(data.tags, false);
                    }
                    else if (TAB_TAGS_REF_CHANNEL === data.reference) {
                        this._containerDispatchers.receiveTagValues(data.tags, true);
                    }
                    break;
                case CHAT_ADMINISTRATORS_CALLBACK:
                    if (data.chatAdministrators.chat) {
                        this._chatDispatchers.chatAdminsReceived(data.chatAdministrators.chat.id, data.chatAdministrators.administrators.map(admin => admin.id));
                        data.chatAdministrators.administrators.forEach(admin => this._profileDispatcher.profileInvalidated(admin.id)
                        // this._chatMemberDispatchers.getMemberChats(admin.id)
                        );
                    }
                    break;
                case CONFIG_QR_CODE_CALLBACK:
                    if (data.chat_id && data.qrCode) {
                        this._chatDispatchers.configQrCodeReceived(data.chat_id, data.qrCode);
                    }
                    break;
                case MY_MENUS_CALLBACK:
                    this._menuUIDispatchers.menusReceiving(data);
                    break;
                case MY_MENU_CALLBACK:
                    this._menuUIDispatchers.menuReceiving(data);
                    if (data.ref && data.ref === CREATE_BOT_MENU_REF) {
                        this._menuUIDispatchers.resetMenuPaging();
                    }
                    break;
                case APP_MENU_CALLBACK:
                    this._appMenuDispatchers.appMenuDetailsReceived(data.app_menu);
                    break;
                case APP_MENUS_CALLBACK:
                    this._appMenuDispatchers.receiveAppMenus(data.app_menus);
                    break;
                case ROLES_CALLBACK:
                    this._chatDispatchers.rolesDelivered(data.roles);
                    break;
                case CHAT_MEMBER_CALLBACK:
                    if (data.recordIndex) {
                        this._bulkDispatchers.recordCreated(data.recordIndex, RecordTypes.MEMBER);
                    }
                    else if ((data &&
                        data.chatMember.status === UserStatus.LEFT &&
                        data.reference === DELETE_MEMBER_FROM_MAIN_CHAT_REF) ||
                        (data && data.chatMember.status === UserStatus.BANNED) ||
                        (data &&
                            data.chatMember.status === UserStatus.ACTIVE &&
                            data.reference === 'UNBAN_REF')) {
                        this._chatMemberDispatchers.removeOrBanUserSuccess(data.chatMember.user.id);
                    }
                    else if (data &&
                        data.reference === DELETE_MEMBER_FROM_SUB_CHAT_REF) {
                        this._chatMemberDispatchers.removeChatFromMemberSuccess(data.chatMember.chat.id);
                    }
                    else {
                        this._chatMemberDispatchers.chatMemberReceiving(data.chatMember);
                    }
                    break;
                case MY_MEMBER_CHATS_CALLBACK:
                    const { user_id, members } = data;
                    this._chatMemberDispatchers.myMemberChatsReceived({
                        user_id,
                        members
                    });
                    break;
                case MY_MEMBERS_CALLBACK:
                    this._chatMemberDispatchers.chatMembersReceived(data.members);
                    if (data.members) {
                        this._membersUiDispatchers.receivedMembersHistoryChunk(data.eop, data.sop, data.members.map(member => {
                            return { user_id: member.user.id };
                        }), data.hash);
                    }
                    break;
                case MY_MEMBER_CALLBACK:
                    if (data.member) {
                        const userNamesObj = {};
                        data.member.forEach(member => {
                            userNamesObj[member.user.id] = member.name;
                        });
                        if (PAYMENT_ORDER_USERS_REF === data.ref) {
                            this._paymentOrdersUiDispatchers.paymentOrdersUsersReceived(userNamesObj);
                        }
                        else if (MY_BOOKING_USERS_REF === data.ref) {
                            this._myBookingsDispatchers.myBookingsUsersReceived(userNamesObj);
                        }
                    }
                    break;
                //
                // case CANCELLED_BOOKING_CALLBACK: {
                //   if (data.data) {
                //     console.log(data.data);
                //     if (data.booking_error) {
                //       switch (data.booking_error) {
                //         case ServerErrors.BookingNotFound:
                //         case ServerErrors.CancelExpired:
                //         case ServerErrors.CancelIsNotAllowedForThisBooking:
                //         case ServerErrors.BookingStartTimePassed:
                //           this._myBookingsDispatchers.receivedMyBookingsError(
                //             data.booking_error
                //           );
                //           break;
                //       }
                //     } else {
                //       this._myBookingsDispatchers.myBookingCancelledSuccess(
                //         data.chat_id,
                //         data.data[0].user_id,
                //         data.data[0].references[0],
                //         data.date,
                //         data.data[0].start_time
                //       );
                //     }
                //   }
                //   break;
                // }
                case WHITELIST_CALLBACK:
                    if (data.whitelist.users.length > 0) {
                        this._whitelistDispatchers.setLoadingScreenStatus('Loading');
                    }
                    this._whitelistDispatchers.receivedWhitelistHistoryChunk(data.eop, data.sop, data.whitelist.users, data.hash);
                    break;
                case ADD_WHITELIST_CALLBACK:
                    this._whitelistDispatchers.resetPaging(null);
                    // this._whitelistDispatchers.addWhitelistSuccess(data.users);
                    break;
                case DELETE_WHITELIST_CALLBACK:
                    this._whitelistDispatchers.deleteUsersFromWhitelistSuccess(data.users);
                    break;
                case WHITELIST_PATTERNS_CALLBACK:
                    this._whitelistPatternsDispatchers.receivedWhitelistPatternsHistoryChunk(data.eop, data.sop, data.whitelistpatten, data.hash);
                    break;
                case ADD_WHITELIST_PATTERNS_CALLBACK:
                    this._whitelistPatternsDispatchers.addWhitelistPatternsSuccess(data.data);
                    break;
                case DELETE_WHITELIST_PATTERNS_CALLBACK:
                    this._whitelistPatternsDispatchers.deletePatternCallback(data.pattern);
                    break;
                case BLACKLIST_CALLBACK:
                    if (data.blacklist.users.length > 0) {
                        this._blackListUiDispatchers.setLoadingScreenStatus('Loading');
                    }
                    this._blackListUiDispatchers.receivedBlacklistsHistoryChunk(data.eop, data.sop, data.blacklist.users, data.hash);
                    break;
                case BLACKLIST_PATTERNS_CALLBACK:
                    this._blacklistPatternsUiDispatchers.receivedBlacklistsPatternsHistoryChunk(data.eop, data.sop, data.blacklistpatten, data.hash);
                    break;
                case DELETE_BLACKLIST_PATTERNS_CALLBACK:
                    this._blacklistPatternsUiDispatchers.deletePatternFromBlacklistSuccess(data.pattern);
                    break;
                case ADD_BLACKLIST_ACK_CALLBACK:
                    if (CREATE_BULK_REF === data.reference) {
                        this._bulkDispatchers.recordCreated(data.recordIndex, RecordTypes.BLACKLIST_SIGNUP);
                    }
                    else {
                        //this._blackListUiDispatchers.resetBlacklistPaging(null);
                        this._blackListUiDispatchers.addBlacklistSuccess(data.users);
                    }
                    break;
                case ADD_BLACKLIST_PATTERNS_ACK_CALLBACK:
                    if (CREATE_BULK_REF === data.reference) {
                        this._bulkDispatchers.recordCreated(data.recordIndex, RecordTypes.BLACKLIST_SIGNUP_PATTERN);
                    }
                    break;
                case DELETE_BLACKLIST_ACK_CALLBACK:
                    this._blackListUiDispatchers.removeUserFromBlacklistSuccess(data.users);
                    break;
                case TICKET_STATUS_CALLBACK:
                    if (data.data) {
                        if (data.response && CANCEL_MY_BOOKING_REF === data.reference) {
                            switch (data.response) {
                                case 500105 /* BookingNotFound */:
                                case 500108 /* CancelExpired */:
                                case 500109 /* CancelIsNotAllowedForThisBooking */:
                                case 500115 /* BookingStartTimePassed */:
                                    this._myBookingsDispatchers.receivedMyBookingsError(data.response);
                                    break;
                            }
                        }
                        else {
                            this._myBookingsDispatchers.myBookingStatusUpdated(data.chat_id, data.data[0].user_id, data.data[0].reference, data.data[0].date, data.data[0].start_time, data.data[0].status, data.data[0].cancelable);
                        }
                    }
                    break;
                // case MY_ADMINS_CALLBACK:
                //   this._chatMemberDispatchers.chatMembersReceived(data.members);
                //   break;
                case MY_PAGE_CALLBACK:
                    if (data.reference) {
                        this._myPageDispatchers.myPageCreated(data.mypage, data.reference);
                    }
                    else {
                        if (data.status && data.status === entityStatuses.DELETED) {
                            this._myPageDispatchers.myPageDeleted(data.id);
                        }
                        else {
                            this._myPageDispatchers.receiveMyPage(data.mypage);
                        }
                    }
                    break;
                case MY_PAGES_CALLBACK:
                    this._myPageDispatchers.receiveMyPages(data.mypages);
                    break;
                case INSTANT_PAGE_CALLBACK:
                    this._instantPageDispatchers.receiveInstantPageDetails(data.instant_page);
                    if (data.reference) {
                        this._myPageDispatchers.pageTemplateCreated(data.reference, data.instant_page.id);
                    }
                    break;
                case INSTANT_PAGES_CALLBACK:
                    this._instantPageDispatchers.receiveInstantPages(data.instant_pages);
                    break;
                case MY_CALL_BACK_STATS_CALLBACK:
                    this._messageDispatchers.setMessageMenuStats(data.message_id, data.data);
                    break;
                case APP_STORE_CALLBACK:
                    this._appPublishingDispatchers.receiveAppStoreInfo(data.app_store);
                    break;
                case MY_MEDIA_CALLBACK:
                    this._mediaCenterDispatchers.myMediaGalleryRcvd(data.data);
                    break;
                case REQUEST_APPLE_CODE_CALLBACK:
                    this._appReleaseDispatchers.showAppleKeyForm(data.release_id);
                    break;
                case BOOKING_PERIODS_CALLBACK: {
                    // console.log(data);
                    if (data.recordIndex) {
                        this._bulkDispatchers.recordCreated(data.recordIndex, RecordTypes.BOOKING_PERIODS);
                    }
                    const bookingPeriods = {};
                    bookingPeriods.chat_id = data.chat_id;
                    bookingPeriods.data = data.data;
                    this._bookingPeriodsDispatchers.receiveBookingPeriods(bookingPeriods);
                    break;
                }
                case GET_BOOKING_EXCEPTIONS_CALLBACK:
                case SET_BOOKING_EXCEPTIONS_CALLBACK: {
                    if (data.recordIndex) {
                        this._bulkDispatchers.recordCreated(data.recordIndex, RecordTypes.BOOKING_HOLIDAYS);
                    }
                    this._bookingExceptionsDispatchers.receiveBookingExceptions(data.chat_id, data.data);
                    break;
                }
                case MY_BOOKINGS_CALLBACK: {
                    if (data.ref && data.ref === REQUEST_MY_BOOKING) {
                        const myBookings = {};
                        myBookings.chat_id = data.chat_id;
                        myBookings.start_date = data.start_date;
                        myBookings.data = data.data;
                        this._myBookingsDispatchers.receiveMyBookings(myBookings);
                    }
                    break;
                }
                case APP_CHANNEL_SETTINGS_CALLBACK:
                    this._appChannelSettingsDispatchers.receiveAppChannelSettingsHistory(data.whiteList_enabled);
                    break;
                case APP_CONFIG_HISTORY_INFO:
                    this._appReleaseDispatchers.rcvdAppReleaseVerData(data.app_config_history);
                    break;
                case PAYMENT_TOKEN_CALLBACK:
                    this._paymentDispatchers.setPaymentToken(data.token);
                    break;
                case PAYMENT_SET_CALLBACK:
                    this._paymentDispatchers.paymentSet();
                    break;
                case PAYMENT_CALLBACK:
                    this._paymentDispatchers.setPaymentInfo(data);
                    break;
                case APP_CHANNEL_DATA_CALLBACK:
                    this._appChannelDataDispatchers.receiveAppChannelData(data.values);
                    break;
                case MAP_SERVICE_CALLBACK:
                    if (data.reference && data.reference === CREATE_MAP_SERVICE_REF) {
                        // this._mapServiceDispatchers.mapServiceCreated(data.mapService);
                        this._mapServiceDispatchers.resetMapServicePaging();
                    }
                    else {
                        if (data.status && data.status === entityStatuses.DELETED) {
                            this._mapServiceDispatchers.mapServiceDeleted(data.id);
                        }
                        else {
                            this._mapServiceDispatchers.mapServiceDetailsReceived(data.mapService);
                        }
                    }
                    break;
                case MAP_SERVICES_CALLBACK:
                    this._mapServiceDispatchers.mapServiceListReceived(data.eop, data.sop, data.mapServices, data.hash);
                    break;
                case MAP_MARKER_CALLBACK:
                    if (data.reference === CREATE_BULK_REF ||
                        data.reference === UPDATE_BULK_REF) {
                        if (data.recordIndex) {
                            this._bulkDispatchers.recordCreated(data.recordIndex, RecordTypes.MAP_TRACKING, data.id, data.reference);
                        }
                    }
                    else if (data.reference &&
                        data.reference === CREATE_MAP_MARKER_REF) {
                        // this._mapMarkerDispatchers.mapMarkerCreated(data.marker);
                        this._mapMarkerDispatchers.resetMapMarkerPaging();
                    }
                    else {
                        if (data.status && data.status === entityStatuses.DELETED) {
                            this._mapMarkerDispatchers.mapMarkerDeleted(data.id);
                        }
                        else {
                            this._mapMarkerDispatchers.mapMarkerDetailsReceived(data.marker);
                        }
                    }
                    break;
                case MAP_MARKERS_CALLBACK:
                    this._mapMarkerDispatchers.mapMarkerListReceived(data);
                    break;
                case MAP_ROUTE_CALLBACK:
                    if (data.reference && data.reference === CREATE_MAP_ROUTE_REF) {
                        // this._mapRouteDispatchers.mapRouteCreated(data.mapRoute);
                        this._mapRouteDispatchers.resetMapRoutePaging();
                    }
                    else {
                        if (data.status && data.status === entityStatuses.DELETED) {
                            this._mapRouteDispatchers.mapRouteDeleted(data.id);
                        }
                        else {
                            this._mapRouteDispatchers.mapRouteDetailsReceived(data.mapRoute);
                        }
                    }
                    break;
                case MAP_ROUTES_CALLBACK:
                    this._mapRouteDispatchers.mapRouteListReceived(data.eop, data.sop, data.mapRoutes, data.hash);
                    break;
                case MAP_TRIP_CALLBACK:
                    if (data.reference && data.reference === CREATE_MAP_TRIP_REF) {
                        // this._mapTripDispatchers.mapTripCreated(data.mapTrip);
                        this._mapTripDispatchers.resetMapTripPaging();
                    }
                    else {
                        if (data.status && data.status === entityStatuses.DELETED) {
                            this._mapTripDispatchers.mapTripDeleted(data.id);
                        }
                        else {
                            this._mapTripDispatchers.mapTripDetailsReceived(data.mapTrip);
                        }
                    }
                    break;
                case MAP_TRIPS_CALLBACK:
                    this._mapTripDispatchers.mapTripListReceived(data.eop, data.sop, data.mapTrips, data.hash);
                    break;
                case MAP_TRIP_USER_CALLBACK:
                    if (data.reference && data.reference === CREATE_MAP_TRIP_USER_REF) {
                        this._mapTripUserDispatchers.mapTripUserCreated(data.mapTripUser);
                    }
                    else {
                        if (data.status && data.status === entityStatuses.DELETED) {
                            this._mapTripUserDispatchers.mapTripUserDeleted(data.id);
                        }
                        else {
                            this._mapTripUserDispatchers.mapTripUserDetailsReceived(data.mapTripUser);
                        }
                    }
                    break;
                case MAP_STOP_TIME_CALLBACK:
                    this._mapStopTimeDispatchers.createMapStopTimeReceived(data.mapStopTime);
                    break;
                case MAP_STOP_TIMES_CALLBACK:
                    this._mapStopTimeDispatchers.MapStopTimesListReceived(data.mapStopTimes);
                    break;
                case MAP_TRIP_USERS_CALLBACK:
                    this._mapTripUserDispatchers.mapTripUserListReceived(data.eop, data.sop, data.mapTripUsers, data.hash);
                    if (data.mapTripUsers && data.mapTripUsers.length > 0) {
                        data.mapTripUsers.map(res => {
                            this._profileDispatcher.profileInvalidated(res.account_id);
                            if (res.checkin_id && res.checkin_id !== '0') {
                                this._mapMarkerDispatchers.getMapMarker(res.checkin_id);
                            }
                            if (res.checkout_id && res.checkout_id !== '0') {
                                this._mapMarkerDispatchers.getMapMarker(res.checkout_id);
                            }
                        });
                    }
                    break;
                case MAP_ACTIVE_TRIPS_CALLBACK:
                    this._mapTripHistoryDispatchers.mapTripHistoryListReceived(data.eop, data.sop, data.mapActiveTrips, data.hash);
                    if (data.mapActiveTrips && data.mapActiveTrips.length > 0) {
                        data.mapActiveTrips.map(res => {
                            if (res.trip_id) {
                                this._mapTripDispatchers.getMapTripById(res.trip_id);
                            }
                        });
                    }
                    break;
                case MAP_ACCOUNT_LINKS_CALLBACK:
                    if (data.reference === 'CreateAccountLinks') {
                        this.mapTripsNotifiersDispatchers.mapAccountLinksCreated(data.mapAccountLinks);
                    }
                    else {
                        data.mapAccountLinks.map(res => {
                            if (res.link_id !== '0') {
                                this._profileDispatcher.profileInvalidated(res.link_id);
                            }
                        });
                        this.mapTripsNotifiersDispatchers.notifiersListReceived(data.mapAccountLinks, data.eop, data.sop, data.reference);
                    }
                    break;
                case MAP_ACCOUNT_LINK_CALLBACK:
                    this.mapTripsNotifiersDispatchers.removeAccountLinkSuccess(data.id);
                    break;
                case MAP_LINKED_ACCOUNTS_CALLBACK:
                    data.mapLinkedAccounts.map(res => this._profileDispatcher.profileInvalidated(res.account_id));
                    this.mapTripsNotifiersDispatchers.mapAccountLinksListReceived(data.mapLinkedAccounts);
                    break;
                case MAP_ASSIGN_TRIPS_CALLBACK:
                    this._driverTripsDispatchers.driverTripsReceived(data.mapAssignTrips);
                    break;
                case MAP_TRIPS_ASSIGN_CALLBACK:
                    this._mapDriverTripsDispatchers.mapDriverReceived(data.tripAssignedAccountsIds);
                    break;
                case OTHER_TRIPS_CALLBACK:
                    this._otherTripsDispatchers.driverTripsReceived(data);
                    break;
                case GET_SMTP_CALLBACK:
                    this._smtpDispatchers.receiveStmp(data);
                    break;
                case CALENDARS_CALLBACK:
                    if (data.calendars && data.calendars.length > 0) {
                        this._calendarUiDispatchers.receivedCalendarHistoryChunk(data.eop, data.sop, data.calendars);
                    }
                    break;
                case CALENDAR_CALLBACK:
                    this._calendarUiDispatchers.calendarReceived(data.calendar);
                    if (data.reference && CREATE_CALENDAR_REF === data.reference) {
                        this._calendarUiDispatchers.setCalendarInCreation(data.calendar);
                    }
                    break;
                case CALENDAR_DETAILS_CALLBACK:
                    this._calendarUiDispatchers.calendarDetailsReceived(data.calendar_id, data.data);
                    break;
                case SERVICE_ORDERS_CALLBACK:
                    if (data.data) {
                        this._serviceOrdersUiDispatchers.receivedServiceOrdersHistoryChunk(data.eop, data.sop, data.data);
                    }
                    break;
                case PAYMENT_ORDERS_CALLBACK:
                    if (data.data) {
                        this._paymentOrdersUiDispatchers.receivedPaymentOrdersHistoryChunk(data.eop, data.sop, data.data);
                    }
                    break;
                case PAYMENT_PROVIDERS_CALLBACK:
                    this._paymentProvidersDispatchers.receivePaymentProviders(data.data);
                    break;
                case ADS_PROVIDERS_CALLBACK:
                    const adsProvider = {};
                    adsProvider.provider_id = data.provider_id;
                    adsProvider.config = data.config;
                    this._adsProvidersDispatchers.receiveAdsProviders(adsProvider);
                    break;
                case SET_PAYMENT_PROVIDER_CALLBACK:
                    this._paymentProvidersDispatchers.receivePaymentProvider(data.provider_id, data.config);
                    break;
                case USER_BALANCE_CALLBACK:
                    this._profileDispatcher.userBalanceReceived(data.user_id, data.user_balance);
                    break;
                case USER_PRODUCT_BALANCE_CALLBACK:
                    this._profileDispatcher.userProductBalanceReceived(data.user_id, data.user_product_balance);
                    break;
                case APPS_CALLBACK:
                    const appLocalInfo = {};
                    appLocalInfo.listOfAvailableApps = data.apps;
                    this._appLocalInfoDispatchers.updateAppLocalInfo(appLocalInfo);
                    break;
                case CASH_PAYMENT_CALLBACK:
                    this._bundlesDispatchers.cashPaymentStatus(data);
                    break;
                case PRODUCTS_CALLBACK:
                    if (data.products) {
                        this._productsDispatchers.receivedProductsHistoryChunk(data.eop, data.sop, data.products);
                    }
                    break;
                case PRODUCT_CALLBACK:
                    if (data.reference === CREATE_BULK_REF ||
                        data.reference === UPDATE_BULK_REF) {
                        if (data.recordIndex) {
                            this._bulkDispatchers.recordCreated(data.recordIndex, RecordTypes.PRODUCT, data.product.id, data.reference);
                        }
                    }
                    else if (data.bundle_id) {
                        this._bundlesDispatchers.bundleProductInfoReceived(data.bundle_id, data.product);
                    }
                    else {
                        if (data.status === entityStatuses.DELETED) {
                            this._productsDispatchers.protuctDeleted(data.id);
                        }
                        else {
                            // ethier way recived product in case ref=create then reset
                            this._productsDispatchers.productReceived(data.product);
                            if (data.reference === CREATE_PRODUCT_REF) {
                                this._productsDispatchers.resetProductsPaging();
                            }
                        }
                    }
                    break;
                case BUNDLES_CALLBACK:
                    if (data.data) {
                        this._bundlesDispatchers.receivedBundlesHistoryChunk(data.eop, data.sop, data.data);
                    }
                    break;
                case BUNDLE_CALLBACK:
                    if (data.reference === CREATE_BULK_REF ||
                        data.reference === UPDATE_BULK_REF) {
                        if (data.recordIndex) {
                            this._bulkDispatchers.recordCreated(data.recordIndex, RecordTypes.BUNDLE, data.bundle.id, data.reference);
                        }
                    }
                    else {
                        if (data.status === entityStatuses.DELETED) {
                            this._bundlesDispatchers.bundleDeleted(data.id);
                        }
                        else {
                            this._bundlesDispatchers.bundleReceived(data.bundle);
                            if (data.reference === CREATE_BUNDLE_REF) {
                                this._bundlesDispatchers.resetBundlesPaging();
                            }
                        }
                    }
                    break;
                case PACKAGES_CALLBACK:
                    if (data.data) {
                        this._packagesDispatchers.receivedPackagesHistoryChunk(data.eop, data.sop, data.data);
                    }
                    break;
                case PACKAGE_CALLBACK:
                    if (data.reference === CREATE_BULK_REF ||
                        data.reference === UPDATE_BULK_REF) {
                        if (data.recordIndex) {
                            this._bulkDispatchers.recordCreated(data.recordIndex, RecordTypes.PACKAGE, data.package_group.id, data.reference);
                        }
                    }
                    else {
                        if (data.status === entityStatuses.DELETED) {
                            this._packagesDispatchers.packageDeleted(data.id);
                        }
                        else {
                            this._packagesDispatchers.packageReceived(data.package_group);
                            if (data.reference === CREATE_PACKAGE_REF) {
                                this._packagesDispatchers.resetPackagesPaging();
                            }
                        }
                    }
                    break;
                case MSTORES_CALLBACK:
                    if (data.data) {
                        this._storesDispatchers.receivedStoreHistoryChunk(data.eop, data.sop, data.data);
                    }
                    break;
                case MSTORE_CALLBACK:
                    if (data.status === entityStatuses.DELETED) {
                        this._storesDispatchers.storeMobileDeleted(data.id);
                    }
                    else {
                        this._storesDispatchers.storeReceived(data.mStore);
                        if (data.reference === CREATE_STORE_REF) {
                            this._storesDispatchers.resetStorePaging();
                        }
                    }
                    break;
                case STOREMENUS_CALLBACK:
                    if (data.data) {
                        this._storeMenuDispatchers.receivedStoreMenuHistoryChunk(data.eop, data.sop, data.data);
                    }
                    break;
                case STOREMENU_CALLBACK:
                    if (data.status === entityStatuses.DELETED) {
                        this._storeMenuDispatchers.storeMenuDeleted(data.id);
                    }
                    else {
                        this._storeMenuDispatchers.storeMenuReceived(data.store_menu);
                        if (data.reference === CREATE_STORE_MENU_REF) {
                            this._storeMenuDispatchers.resetStoreMenuPaging();
                        }
                    }
                    break;
                case SUBMENUS_CALLBACK:
                    if (data.data) {
                        this._subMenuDispatchers.receivedSubMenuHistoryChunk(data.eop, data.sop, data.data);
                    }
                    break;
                case SUBMENU_CALLBACK:
                    // this._storeMenuDispatchers.subMenuStoreReceived(data.);
                    if (data.reference === CREATE_SUB_MENU_REF) {
                        this._subMenuDispatchers.resetSubMenuPaging();
                    }
                    break;
                case CONNECTE_STRIPE_CALLBACK:
                    if (data.stripe_connected_account_url) {
                        window.open(data.stripe_connected_account_url);
                    }
                    break;
                default:
                    break;
            }
        }
    }
    chatReceived(data) {
        const createdGroup = {};
        createdGroup.id = data.chat_id;
        createdGroup.admin = true;
        this._chatDispatchers.newChatReceived(createdGroup);
        return createdGroup;
    }
}
RootStoreService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RootStoreService_Factory() { return new RootStoreService(i0.ɵɵinject(i1.AuthDispatchers), i0.ɵɵinject(i2.MessageDispatchers), i0.ɵɵinject(i3.ProfileDispatchers), i0.ɵɵinject(i4.MyProfileDispatchers), i0.ɵɵinject(i5.ChatDispatchers), i0.ɵɵinject(i6.ChatMemberDispatchers), i0.ɵɵinject(i7.CampaignDispatchers), i0.ɵɵinject(i8.CampaignUIDispatchers), i0.ɵɵinject(i9.CouponDispatchers), i0.ɵɵinject(i10.CouponUIDispatchers), i0.ɵɵinject(i11.InstantDispatchers), i0.ɵɵinject(i12.AppConfigDispatchers), i0.ɵɵinject(i13.AppConfigHistoryDispatchers), i0.ɵɵinject(i14.AppReleaseDispatchers), i0.ɵɵinject(i15.ContainerDispatchers), i0.ɵɵinject(i16.EventUiDispatchers), i0.ɵɵinject(i17.BookingUiDispatchers), i0.ɵɵinject(i18.SubGroupUiDispatchers), i0.ɵɵinject(i19.SubChannelUiDispatchers), i0.ɵɵinject(i20.VirtualAppUiDispatchers), i0.ɵɵinject(i21.MembersUiDispatchers), i0.ɵɵinject(i22.BookingPeriodsDispatchers), i0.ɵɵinject(i23.MyBookingsDispatchers), i0.ɵɵinject(i24.AppMenuDispatchers), i0.ɵɵinject(i25.MyPageDispatchers), i0.ɵɵinject(i26.InstantPageDispatchers), i0.ɵɵinject(i27.AppPublishingDispatchers), i0.ɵɵinject(i28.MediaCenterDispatchers), i0.ɵɵinject(i29.PaymentDispatchers), i0.ɵɵinject(i30.BulkDispatchers), i0.ɵɵinject(i31.AppChannelDataDispatchers), i0.ɵɵinject(i32.BookingExceptionsDispatchers), i0.ɵɵinject(i33.MapServiceDispatchers), i0.ɵɵinject(i34.MapMarkerDispatchers), i0.ɵɵinject(i35.MapRouteDispatchers), i0.ɵɵinject(i36.MapTripDispatchers), i0.ɵɵinject(i37.MapTripUserDispatchers), i0.ɵɵinject(i38.CalendarUiDispatchers), i0.ɵɵinject(i39.ServiceOrdersUiDispatchers), i0.ɵɵinject(i40.PaymentOrdersUiDispatchers), i0.ɵɵinject(i41.PaymentProvidersDispatchers), i0.ɵɵinject(i42.AdsProvidersDispatchers), i0.ɵɵinject(i43.ProductsUiDispatchers), i0.ɵɵinject(i44.BundlesUiDispatchers), i0.ɵɵinject(i45.PackagesUiDispatchers), i0.ɵɵinject(i46.AppLocalInfoDispatchers), i0.ɵɵinject(i47.StoreUiDispatchers), i0.ɵɵinject(i48.SubMenuUiDispatchers), i0.ɵɵinject(i49.StoreMenuUiDispatchers), i0.ɵɵinject(i50.MenuUIDispatchers), i0.ɵɵinject(i51.WhitelistPatternsUiDispatchers), i0.ɵɵinject(i52.WhitelistUiDispatchers), i0.ɵɵinject(i53.BlackListUiDispatchers), i0.ɵɵinject(i54.BlackListPatternsUiDispatchers), i0.ɵɵinject(i55.AppChannelSettingsDispatchers), i0.ɵɵinject(i56.MapTripHistoryDispatchers), i0.ɵɵinject(i57.MapStopTimeDispatchers), i0.ɵɵinject(i58.MapTripsNotifiersDispatchers), i0.ɵɵinject(i59.DriverTripsDispatchers), i0.ɵɵinject(i60.MapDriverDispatchers), i0.ɵɵinject(i61.OtherTripsDispatchers), i0.ɵɵinject(i62.StmpDispatchers)); }, token: RootStoreService, providedIn: "root" });
